const DEALER_SPECIALTY_DESCRIPTIONS = {
    "Retail Gun Store": [
        "Full-service retail store offering handguns, rifles, shotguns, ammo, and accessories.",
        "Locally trusted shop for all your firearm and tactical gear needs.",
        "We stock everything from entry-level pistols to high-end rifles and optics."
    ],

    "Online Dealer": [
        "Nationwide shipping and fast online transfers made easy.",
        "We specialize in online firearm sales with secure and hassle-free FFL transfers.",
        "Buy online with confidence — affordable shipping and responsive support."
    ],

    "Gunsmith": [
        "Certified gunsmith offering cleanings, repairs, builds, and custom upgrades.",
        "From minor tweaks to full restorations — we get your firearms running flawlessly.",
        "Trigger jobs, barrel threading, and more. We fix what others won’t touch."
    ],

    "Range / Shooting Club": [
        "Safe, modern shooting range for members and the public.",
        "Indoor/outdoor range with rental guns, classes, and private training available.",
        "Join our club for exclusive access, competitions, and special events."
    ],

    "Class 3 / NFA Dealer": [
        "Authorized NFA/Class 3 dealer for suppressors, SBRs, and full-auto firearms.",
        "We make NFA ownership easy — including Form 4 and trust support.",
        "Buy with confidence — silencer and SBR transfers done fast and legally."
    ],

    "Pawn Shop": [
        "Licensed pawn shop dealing in firearms, gold, electronics, and more.",
        "We offer fair deals on firearm pawns, purchases, and transfers.",
        "Buy, sell, or trade — cash paid on the spot for your guns and gear."
    ],

    "Private Collector": [
        "Private FFL collector focused on historical and rare firearms.",
        "Curated inventory of collectible and hard-to-find firearms.",
        "Primarily appointment-based — serious collectors only."
    ],

    "Supports NFA Transfers": [
        "We facilitate NFA/Class 3 transfers including suppressors, SBRs, and full-auto items.",
        "Need help with a Form 4? We’ll walk you through every step of the NFA transfer process.",
        "Specializing in trust and individual NFA transfers – smooth, compliant, and quick."
    ],

    "Offers Fingerprinting": [
        "We offer FD-258 fingerprint card services for ATF forms and background checks.",
        "On-site fingerprinting available – no appointment necessary.",
        "ATF-compliant fingerprinting done quickly and securely."
    ],

    "Home-Based Dealer": [
        "Licensed home-based FFL — transfers by appointment only.",
        "Low overhead, better prices. Flexible hours, private setting.",
        "Same professional service without the retail markup."
    ],

    "Manufacturer": [
        "Licensed firearm manufacturer offering custom builds and serialized parts.",
        "From precision machining to full rifle builds — proudly made in-house.",
        "OEM and private label manufacturing available upon request."
    ],

    "Instructor / Trainer": [
        "Certified firearms instructor offering safety, CCW, and tactical courses.",
        "Private and group firearms training tailored to all skill levels.",
        "Real-world firearm instruction from a certified pro — book today."
    ],

    "Appointments Available": [
        "Appointments available — contact us to schedule a visit at your convenience.",
        "Flexible scheduling for transfers, consultations, and pickups.",
        "Book your appointment online or by phone — fast and easy.",
        "Evening and weekend appointments available upon request."
    ],

    "Accepts Credit Cards": [
        "We accept all major credit and debit cards for your convenience.",
        "Fast, secure payments — credit cards welcome.",
        "No cash? No problem. We take credit cards.",
        "Visa, Mastercard, AmEx — we’ve got you covered."
    ],

    "Used Firearms Accepted": [
        "We buy or trade used firearms — get a fair market offer fast.",
        "Bring in your used guns — we make cash or trade offers on the spot.",
        "Sell your used firearm safely and legally through our shop.",
        "Looking to upgrade? Trade in your used guns toward something new."
    ],

    "Consignment Sales": [
        "Let us sell your firearm for you — we handle everything.",
        "Consign your firearms and get exposure to our trusted customer base.",
        "We list, market, and sell your gun — you get paid when it sells.",
        "Want top dollar? Consignment puts your gun in front of serious buyers."
    ],
};

export default DEALER_SPECIALTY_DESCRIPTIONS;